import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  configurations,
  configurationsForm,
  Clients,
  ClientsForm,
  Products,
  ProductsForm,
  Invoices,
  InvoicesForm,
  DeliveryNotes,
  DeliveryNotesForm,
} from "./Reducers";

export default combineReducers({
  DeliveryNotes,
  DeliveryNotesForm,
  Invoices,
  InvoicesForm,
  Products,
  ProductsForm,
  Clients,
  ClientsForm,
  configurations,
  configurationsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
